<div [class]="['avatar__overlapping__icon']" *ngIf="overlappingTypeValue$ | async">
  <mat-icon
    [matTooltip]="(overlappingTypeValue$ | async)!"
    [svgIcon]="overlappingSvgIcon"
    [class]="iconClasses$ | async"
    *ngIf="overlappingTypeValue$ | async"
  ></mat-icon>
</div>
<div [ngStyle]="{ width: size + 'px', height: size + 'px' }" class="avatar">
  <ng-container *ngIf="!url || url === ''; else photoTemplate">
    <mat-icon
      *ngIf="setIconSize"
      [ngStyle]="{ 'font-size': size + 'px' }"
      [ngClass]="{ avatar__icon: true, centralize: centralize }"
      >account_circle</mat-icon
    >
    <mat-icon *ngIf="!setIconSize" [ngClass]="{ avatar__icon: true, centralize: centralize }">account_circle</mat-icon>
  </ng-container>

  <ng-template #photoTemplate>
    <img [src]="url" [width]="size" [height]="size" class="avatar__photo" alt="" loading="lazy" />
  </ng-template>
</div>
